import { JSX, StrictMode } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { ConfigurationService } from '../../../services/configuration.service';
import Competitions from './components/Competitions';
import Competition from './components/Competition';
import LoggedOff from '../LoggedOff';
import Municipalities from './components/Municipalities';
import Municipality from './components/Municipality';
import Administrator from '.';
import Statistics from './components/Statistics';
import Accounts from './components/Accounts';
import NotFoundRedirect from '../Shared/NotFoundRedirect';

const router = createBrowserRouter(
  [
    {
      path: '/',
      element: <Administrator />,
    },
    {
      path: '/tavlingar',
      element: <Competitions />,
    },
    {
      path: '/tavlingar/:competitionId/redigera',
      element: <Competition />,
    },
    {
      path: '/tavlingar/lagg-till',
      element: <Competition />,
    },
    {
      path: '/kommuner',
      element: <Municipalities />,
    },
    {
      path: '/kommuner/:municipalityId',
      element: <Municipality />,
    },
    {
      path: '/statistik',
      element: <Statistics />,
    },
    {
      path: '/anvandare',
      element: <Accounts />,
    },
    {
      path: '/session-utgangen',
      element: (
        <LoggedOff headingText="Du har blivit utloggad" bodyText="Efter en tids inaktivitet loggas du automatiskt ut för att skydda dina uppgifter. Logga in igen för att fortsätta använda sajten." />
      ),
    },
    {
      path: '*',
      element: <NotFoundRedirect />,
    },
  ],
  { basename: ConfigurationService.get('paegnabenadminpage.basename') }
);

export default function createRouterProvider(): JSX.Element {
  return (
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>
  );
}
